import React from 'react'
import { CustomInput, CustomMultiSelect, CustomSelect } from '../../../Components/CustomInput'
import Countries from '../../../../content/countries.json'
import { CustomButton } from '../../../Components/CustomButton'
import { useForm } from '@formspree/react';

import Successful from "../../../images/successful.json";
import Lottie from 'react-lottie-player';


const GetStartedForm = ({hasText, value}) => {
     const [state, handleSubmit] = useForm("xoqryqbv");
     
     if (state.succeeded) {
         return  <div className="text-center mb-5">
        <h2>Thanks for reaching Us!</h2>
        <p>Our team will get back to you soon.</p>
             <Lottie
            loop={false}
            animationData={Successful}
            play
            style={{ width: "100%", height: 200}}
            />
            {/* <Link to={HOME_PAGE}>Back Home</Link>    */}
        </div>
     }


    const CountryOptions = Countries.sort((a, b) => a.name.localeCompare(b.name)).map((item) => 
    ({ value: item.name, label: item.emoji + ' ' + item.name  })
    )


    const planOptions = [
        { value: 'Basic', label: 'Basic' },
        { value: 'Premium', label: 'Premium' },
        { value: 'Business', label: 'Business' },
      ]

   
  return (
      <>
     {
         hasText && (
            <div className="text-center">
          <h4 style={{ fontSize: 30, fontWeight:700, fontFamily: "Poppins, sans-serif" }}>Get started for free today</h4>
          <p style={{ fontSize: 14, fontWeight:400, fontFamily: "Poppins, sans-serif" }}>30-day free trial | No payment required.</p>
       </div>
         )
     }
    <div className="request">
    
        <form className="request__form pt-3 pb-5" onSubmit={handleSubmit}>
        <div className="row ">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput label="First Name" type="firstname" name="Firstname"  hasRequired/>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput  label="Last Name" type="lastname" name="Lastname" hasRequired/>
                </div>
            </div>
            <div className="row my-2">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput label="Email" type="email" name="Email"  hasRequired/>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput  label="Phone" type="phone" name="Phone Number" hasRequired/>
                </div>
            </div>
            {
                value?.basic && (<>
                    <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput label="Product" type="product" name="Product" value="Oil & Gas Transportation" readOnly={true}/>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    {/* <CustomMultiSelect label="Plan"  name="plan" defaultInputValue={value.basic} options={planOptions} /> */}
                    <CustomSelect label="Plan"  name="Plan" value={value.basic}>
                        {
                            planOptions.map((item, index) => (
                                <option value={item.value} key={index}>{item.label}</option>
                            ))
                        }
                    </CustomSelect>
                </div>
            </div>
           
                </>)
            }
            <div className="row ">
                <div className="col-sm-12 col-md-6 col-lg-6">
                    <CustomInput label="Company" type="company" name="company"  />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                <CustomMultiSelect label="Country"  name="country" options={CountryOptions} />
                </div>
            </div>
            <div className="row mt-4">
                <div className="d-flex justify-content-center primaryBtn ">
                    <CustomButton type="submit" text="Get Started" disabled={state.submitting ? true : false}/>
                </div>
            </div>
        </form>
        
    </div>

      </>
  )
}

export default GetStartedForm